import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, PhoneCall } from "lucide-react";
import { Button } from "./ui/button";
import { company } from "../mock";
import TechBackdrop from "./TechBackdrop";

export default function CtaBand() {
  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-slate-950 text-white px-8 lg:px-14 py-14 lg:py-16">
          <div className="absolute inset-0 circuit-lines opacity-40" />
          <div className="absolute inset-0 opacity-25">
            <TechBackdrop variant="lines" opacity={0.7} />
          </div>
          <div className="absolute -top-32 -right-24 w-[30rem] h-[30rem] rounded-full bg-brand-500/20 blur-3xl" />
          <div className="absolute -bottom-24 -left-24 w-[24rem] h-[24rem] rounded-full bg-cyan-500/10 blur-3xl" />

          <div className="relative grid lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-brand-400/30 bg-brand-400/10 text-brand-300 text-[12px] tracking-wide">
                <span className="h-1.5 w-1.5 rounded-full bg-brand-400" /> Ready when you are
              </div>
              <h3 className="font-display mt-4 text-3xl lg:text-4xl font-bold leading-tight">
                Let’s scope your next AIX or PowerHA engagement.
              </h3>
              <p className="mt-3 text-slate-300 max-w-2xl">
                A 30-minute technical call with a senior engineer — no sales intro, no slideware. We’ll give you a clear read on scope, effort and risk.
              </p>
            </div>
            <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3 lg:items-end">
              <Link to="/contact" className="w-full">
                <Button className="w-full rounded-full h-12 bg-brand-400 hover:bg-brand-300 text-slate-950 font-semibold">
                  Book the call <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
              <a href={`tel:${company.phone.replace(/\s/g, "")}`} className="w-full">
                <Button variant="outline" className="w-full rounded-full h-12 border-slate-700 bg-transparent text-white hover:bg-white/5">
                  <PhoneCall className="mr-2 h-4 w-4" /> {company.phone}
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
